import { FaFilePdf, FaFileCsv, FaFileWord } from "react-icons/fa";

const JournalComponent = ({ journalData }) => {
  return (
    <div className="p-6">
      {journalData?.data?.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {journalData.data.map((item) => {
            const fileUrl = item.latest_media_url || "";
            const fileExt = fileUrl.split(".").pop().toLowerCase();

            const isPdf = fileExt === "pdf";
            const isCsv = fileExt === "csv";
            const isDocx = fileExt === "docx";
            const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(
              fileExt
            );

            return (
              <div key={item.item_id} className="p-4 rounded-lg text-center">
                {fileUrl ? (
                  isPdf || isCsv || isDocx ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full h-40 flex flex-col items-center justify-center bg-gray-100 rounded-lg text-gray-700 hover:text-gray-900"
                    >
                      {isPdf && <FaFilePdf className="text-6xl text-red-500" />}
                      {isCsv && (
                        <FaFileCsv className="text-6xl text-green-500" />
                      )}
                      {isDocx && (
                        <FaFileWord className="text-6xl text-blue-500" />
                      )}
                      <span className="mt-2 text-sm">
                        View {fileExt.toUpperCase()}
                      </span>
                    </a>
                  ) : isImage ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full h-40 flex flex-col items-center justify-center bg-gray-100 rounded-lg text-gray-700 hover:text-gray-900"
                    >
                      <img
                        src={fileUrl}
                        alt={item.item_name}
                        className="w-full h-40 object-cover rounded-lg"
                      />
                    </a>
                  ) : (
                    <div className="w-full h-40 flex items-center justify-center bg-gray-200 rounded-lg text-gray-600">
                      Unsupported File Type
                    </div>
                  )
                ) : (
                  <div className="w-full h-40 flex items-center justify-center bg-gray-200 rounded-lg text-gray-600">
                    No File
                  </div>
                )}

                <div className="flex justify-between p-6 items-center mt-2 border-b pb-1">
                  <span className="font-bold text-secondary">
                    {item.item_name}
                  </span>
                  <span
                    className={`font-bold ${
                      parseFloat(item.roi) < 0
                        ? "text-expense"
                        : "text-secondary"
                    }`}
                  >
                    ROI {parseFloat(item.roi).toFixed(1)}%
                  </span>
                </div>

                <div className="mt-2 px-6 flex justify-between">
                  <span className="text-secondary">% Luxury assets</span>
                  <span className="text-secondary">
                    {item.contribution
                      ? Number(item.contribution).toFixed(2) + "%"
                      : "N/A"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-10">
          No Data Available
        </div>
      )}
    </div>
  );
};

export default JournalComponent;
